import React from 'react';
import Select from '../Select/Select';
import { workStatusOptions } from '../../pages/Deal/DealCreate/greyAppeal';

export const WORK_STATUSES = [
    { value: "0", label: "ÐÐ±ÑÑÐ½ÑÐ¹ ÐºÐ»Ð¸ÐµÐ½Ñ Ñ ÐÐ¦ÐÐ" },
    { value: "9", label: "ÐÐ»Ð¸ÐµÐ½Ñ Ñ Ð²ÑÐ¿Ð¸ÑÐºÐ¾Ð¹ ÐÐÐ£" },
    { value: "3", label: "ÐÐ¾ÐµÐ½Ð½Ð¾ÑÐ»ÑÐ¶Ð°ÑÐ¸Ð¹" },
    { value: "7", label: "ÐÐµÐ½ÑÐ¸Ð¾Ð½ÐµÑ (Ð² Ñ.Ñ. Ð¿Ð¾ Ð²ÑÑÐ»ÑÐ³Ðµ Ð»ÐµÑ)" },
    { value: "10", label: "Ð Ð°Ð±Ð¾ÑÐ°ÑÑÐ¸Ð¹ Ð¿ÐµÐ½ÑÐ¸Ð¾Ð½ÐµÑ (Ð² Ñ.Ñ. Ð¿Ð¾ Ð²ÑÑÐ»ÑÐ³Ðµ Ð»ÐµÑ)" },
    { value: "6", label: "ÐÐ±ÑÑÐ½ÑÐ¹ ÐºÐ»Ð¸ÐµÐ½Ñ ÑÐ¾ ÑÐ¿ÑÐ°Ð²ÐºÐ¾Ð¹ c ÑÐ°Ð±Ð¾ÑÑ" },
];

const SelectWorkStatus = ({ ...props }) => {
  return <Select options={workStatusOptions(WORK_STATUSES)} label={'Ð¡ÑÐ°ÑÑÑ ÐºÐ»Ð¸ÐµÐ½ÑÐ°'} placeholder={'ÐÑÐ±ÐµÑÐ¸ÑÐµ Ð¸Ð· ÑÐ¿Ð¸ÑÐºÐ°'} {...props} />;
};

export default SelectWorkStatus;
